<template>
    <div class="date-filter">
        <div class="date-table">
            <div class="thead">
                <div class="tr">
                    <div v-for="(item, key) in dateTableHeader"
                         :key="key"
                         class="td">
                        {{item.text}}
                    </div>
                </div>
            </div>
            <div class="tbady">
                <div v-for="(item, key) in dateTableItems"
                     :key="key"
                     class="tr">
                    <div v-for="(item2, key2) in item"
                         :key="key2"
                         :style="{'background-color': item2.quotaColor}"
                         :class="['td', {'active': item2.cost}, {'checked': item2.isChecked}]"
                         @click="setDate(item2)">
                        <span v-if="key2 === 0">{{item2.text}}</span>
                        <span v-else-if="item2.cost">{{localizeList.fromPrice}} {{correctPrice(item2.cost)}} {{getCurrencyDisplayBySettings(rate)}}</span>
                        <span v-else>–</span>
                    </div>
                </div>
            </div>
            <div class="top-slider">
                <img @click="slideDate('left', 0)"
                     src="../../assets/images/long-angle.svg" width="28px" alt="">
                {{localizeList.flightDepartureUpper}}
                <img @click="slideDate('right', 0)"
                     src="../../assets/images/long-angle.svg" width="28px" class="right" alt="">
            </div>
            <div v-show="directDOM === 1" class="left-slider">
                <img @click="slideDate('right', 1)"
                     src="../../assets/images/long-angle.svg" width="28px" alt="">
                {{localizeList.returnUpper}}
                <img @click="slideDate('left', 1)"
                     src="../../assets/images/long-angle.svg" width="28px" class="right" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dateTable",
        props: {
            rate: {
                type: Object,
                required: true
            },
            dateTableHeader: {
                type: Array,
                required: true
            },
            dateTableItems: {
                type: Array,
                required: true
            },
            directDOM: {
                type: Number,
                required: true
            }
        },
        methods: {
            slideDate(to, n) {
                this.$emit("slideDate", [to, n])
            },
            setDate(item) {
                this.$emit("setDate", item)
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val)
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
        }
    }
</script>

<style scoped>
    /*DATE TABLE*/

    .date-filter {
        position: relative;
        padding: 20px 0 0 20px;
    }
    .date-table .top-slider,
    .date-table .left-slider {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
    }
    .date-table .top-slider{
        top: -8px;
        left: 20px;
        right: 0;
    }
    .date-table .left-slider{
        top: calc(50% + 10px);
        left: 6px;
        transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        width: 380px;
    }
    .date-table .top-slider .right,
    .date-table .left-slider .right {
        transform: rotate(180deg);
        cursor: pointer;
    }
    .date-table .top-slider img,
    .date-table .left-slider img {
        cursor: pointer;
        transition: all .2s;
        opacity: .7;
    }
    .date-table .top-slider img:hover,
    .date-table .left-slider img:hover {
        opacity: 1;
    }

    .date-table .thead .tr {
        display: flex;
    }

    .date-table .thead .td {
        flex: 1;
        background-color: var(--primary-2-color);
    }

    .date-table .thead .td,
    .date-table .tbady .td {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--lighten-4-color);
        border-right: none;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 15px;
        line-height: 19px;
        padding: 14px 0;
        color: var(--dark-1-color);
    }

    .date-table .thead .td:last-child {
        border-right: 1px solid var(--lighten-4-color);
    }

    .date-table .tbady .tr {
        display: flex;
    }

    .date-table .tbady .td {
        flex: 1;
    }

    .date-table .tbady .td {
        border-top: none;
    }

    .date-table .tbady .tr .td:first-child {
        background-color: var(--primary-2-color);
    }
    .date-table .tbady .tr .td:not(:first-child) {
        color: var(--white-color);
    }
    .date-table .tbady .tr .td.active {
        opacity: .8;
        cursor: pointer;
        transition: all .2s;
        color: var(--white-color);
    }
    .date-table .tbady .tr .td.active:hover {
        opacity: .6;
    }
    .date-table .tbady .tr .td.checked {
        opacity: 1;
    }
    .date-table .tbady .td:last-child {
        border-right: 1px solid var(--lighten-4-color);
    }
</style>